import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";

export class MyWalletDataView extends Container {
    protected readonly descriptionText: Text;
    protected readonly textFieldPlaceholder: Sprite;

    public constructor(myWalletResources: MyWalletResourcePackage, descriptionText: string) {
        super();
        this.descriptionText = new Text(descriptionText, new MyWalletDataDescriptionTextStyle());
        this.textFieldPlaceholder = new Sprite(myWalletResources.assets_views_my_wallet_ui_text_field_png);
        this.textFieldPlaceholder.position.set(this.descriptionText.width + 20, 0);
        this.addChild(this.descriptionText, this.textFieldPlaceholder);
    }
}

class MyWalletDataDescriptionTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32,
            fill: 'BCD8F2',
            align: 'center'
        });
    }
}

export class MyWalletDataTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.BEBAS_NEUE_PRO_SMERG_BOLD,
            fontSize: 36,
            fill: 'BCD8F2',
            trim: true
        });
    }
}
